import angular from 'angular';
import resetAccountPasswordRouting from './reset-account-password-routing-module';
import ResetAccountPasswordComponent from './components/reset-account-password/reset-account-password-component';
import ResetPasswordButtonComponent from './components/reset-password-button/reset-password-button-component';

export default angular
  .module('reset-account-password', [resetAccountPasswordRouting.name])
  .component('resetAccountPassword', new ResetAccountPasswordComponent())
  .component('resetPasswordButton', new ResetPasswordButtonComponent());



// WEBPACK FOOTER //
// ./src/modules/auth/components/reset-account-password/reset-account-password-module.js